module.exports = __webpack_public_path__ + "FixelText-BoldItalic.2be937caa2f1bf32df11.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/fixelText/FixelText-BoldItalic.woff2
// module id = ./src/assets/webfonts/fixelText/FixelText-BoldItalic.woff2
// module chunks = styles